import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { CompaniesComponent } from './companies.component';

@NgModule({
  entryComponents: [
    CompaniesComponent
  ],
  declarations: [
    CompaniesComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,

    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule
  ],
  exports: [
    CompaniesComponent
  ]
})
export class CompaniesComponentModule {}
